import { type VariantProps, cv, cx } from "@suse-o11y/class-variance";
import { IconLoading3QuartersOutlined } from "@suse-o11y/icons";
import { Spin } from "antd/es";
import React from "react";

import styles from "./loading-spinner.module.css";

const variants = cv(styles.loadingSpinner, {
	variants: {
		size: {
			small: "[&_.anticon]:text-[14px]",
			medium: "[&_.anticon]:text-[28px]",
			large: "[&_.anticon]:text-[42px]",
		},
	},
	defaultVariants: {
		size: "medium",
	},
});

export interface LoadingSpinnerProps extends VariantProps<typeof variants> {
	className?: string;
}

export const LoadingSpinner = React.forwardRef<HTMLDivElement, LoadingSpinnerProps>(
	({ size, className, ...props }, ref) => (
		<div data-testid="loading-spinner" ref={ref} {...props} className={variants({ className, size })}>
			<Spin className="flex" indicator={<LoadingIcon />} />
		</div>
	),
);

export const LoadingIcon: React.FC<React.ComponentProps<typeof IconLoading3QuartersOutlined>> = ({
	className,
	...props
}) => <IconLoading3QuartersOutlined spin {...props} className={cx("text-primary-600", className)} />;
